/* eslint-disable */
import PropTypes from 'prop-types';
import InfoModal from 'components/InfoModal/InfoModal';
import { Table, SelectTamanoPagina, Input, Button, Tooltip } from 'components';
import { DatePicker, message, Spin, Checkbox, Row, Col } from 'antd';
import { FileSearchOutlined, EyeOutlined, DownloadOutlined } from '@ant-design/icons';
import './TablaMonitoreos.scss';
import { selectMonitoreosEspectacularesState } from 'selectors/monitoreosEspectaculares.selector';
import { selectMenuState } from 'selectors/auth.selector';
import { getMonitoreoEspectacularesViaPublica } from 'actions/espectaculares.actions';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDebounce } from 'hooks/useDebounce';
import { useDispatch, useSelector } from 'react-redux';
import { base64toBlob } from 'utils/file';
import { downloadExcelPropViaP } from 'actions/files.actions';
import { getMenuPermissions } from 'utils/getMenuPermissions';
import { MONITOREOS_ESPECTACULARES, ACTA_INICIO } from 'constants/tipoMonitoreos';
import {
  NOMBRE_MENU_ESPECTACULARES,
  NOMBRE_MENU_PERMISO_EDITAR,
  NOMBRE_MENU_PERMISO_VALIDAR,
  NOMBRE_SUBMENU_PROP_VIA_PUB
} from 'constants/menuNombres';
import { validarHallazgosByMoni } from 'actions/monitoreos.actions';
import * as MensGrales from 'constants/MensajesGenerales';
import { getPdfActa } from 'actions/pdf.actions';
import { PDF_ACTA_INICIO } from 'constants/pdfTypes';
import { DOWNLOAD_TYPES } from 'constants/downloadTypes';
import { ModalPdf, DescargaPDF } from 'components/ModalPdf/ModalPdf';
import { generateId } from 'utils/idGenerator';
import { getFolioNumber } from 'utils/getFolioNumber';
import { filterList } from 'utils/filterList';
import { useNavigate } from 'react-router-dom';
import { DATE_FORMAT_DATE_PICKER } from 'constants/dateFormat';

// MNI - Genera formatos PDF al validar
import { generarPDFMonitoreosValidacion } from 'services/monitoreos.service';

const DEBOUNCE_TIME_FILTER = 1000;

const TablaMonitoreos = ({ mainFilters, seleccion }) => {
  const navigate = useNavigate();
  const filtersRef = useRef({});
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({});
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const [pdfActa, setPdfActa] = useState(null);
  const [isModalPdfOpen, setIsModalPdfOpen] = useState(false);
  const [isActaDescargaId, setIsActaDescargaId] = useState(null);
  const [isMonitoreoId, setIsMonitoreoId] = useState(null);
  const [loadingBtnValidar, setLoadingBtnValidar] = useState(false);
  const [monitoreosListCopy, setMonitoreosListCopy] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [isVisibleSuccesModal, setIsVisibleSuccessModal] = useState(false);

  const applyFilter = useDebounce((fields) => setFilters(fields), DEBOUNCE_TIME_FILTER);

  const menu = useSelector(selectMenuState);
  const { loading, data } = useSelector(selectMonitoreosEspectacularesState);
  const showTotal = (total, range) => {
    return `Mostrando del ${range[0]} al ${range[1]} de ${total} registros`;
  };

  const [pagination, setPagination] = useState({
    position: ['bottomRight'],
    showQuickJumper: true,
    size: 'small',
    pageSize: 10,
    current: 1,
    showTotal,
    total: 0,
    showSizeChanger: false
  });

  const getChangedValidateHallazgo = (array1, array2) => {
    return array1
      .filter((item1, index) => {
        const item2 = array2[index];
        return item1.checkValidacion !== item2.checkValidacion && item1.checkValidacion === true;
      })
      .map((item) => {
        return { idMonitoreo: item.idMonitoreo, pkMonitoreo: item.idMonitoreo, hallazgos: item.hallazgos };
      });
  };

  const getChangedDeValidateHallazgo = (array1, array2) => {
    return array1
      .filter((item1, index) => {
        const item2 = array2[index];
        return item1.checkValidacion !== item2.checkValidacion && item1.checkValidacion === false;
      })
      .map((item) => {
        return { idMonitoreo: item.idMonitoreo, pkMonitoreo: item.idMonitoreo };
      });
  };

  const handleChangePageSize = (pageSize) => {
    // MNI - Se resetea a 1 la paginación al cambiar el valor de la paginación.
    setPagination((prevPagination) => ({ ...prevPagination, pageSize, current: 1 }));
  };

  const handleChangeFilter = ({ target }) => {
    const { value, name } = target;
    filtersRef.current[name] = value;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeFilterNumber = ({ target }) => {
    const { value, name } = target;
    const num = Number(value);
    filtersRef.current[name] = num;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeDateFilterInicio = (date) => {
    // console.log(date, 'date');
    filtersRef.current.fechaRegistroAI = date || null;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeDateFilterCierre = (date) => {
    filtersRef.current.fechaRegistroAC = date || null;
    applyFilter({ ...filtersRef.current });
  };

  const handleDownloadExcel = async () => {
    try {
      setDownloadingExcel(true);
      const { success, response } = await dispatch(downloadExcelPropViaP(data));
      if (success && response.data.excel64) {
        const url = window.URL.createObjectURL(
          base64toBlob(response.data.excel64.base64, response.data.excel64.tipo)
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.data.excel64.nombre);
        link.click();
        setDownloadingExcel(false);
      }
      setDownloadingExcel(false);
    } catch (error) {
      console.log('Error', error);
    }
  };

  const handleGetPdfActa = async (idMonitoreo, option, idActaDescarga) => {
    const payload = {
      tipoMonitoreo: MONITOREOS_ESPECTACULARES,
      tipoActa: ACTA_INICIO,
      tipoDescarga: DOWNLOAD_TYPES.TESTIGOS.value,
      listaIdMonitoreos: [idActaDescarga]
    };
    try {
      const { success, response } = await dispatch(getPdfActa(payload));

      const { archivo } = response.data;
      if (success) {
        setPdfActa(archivo);

        if (option === 'eyeOutlined') {
          setIsModalPdfOpen(true);
          setIsActaDescargaId(idActaDescarga);
          setIsMonitoreoId(idMonitoreo);
        }

        if (option === 'downloadOutlined') {
          DescargaPDF(archivo, PDF_ACTA_INICIO, idMonitoreo, idActaDescarga);
        }
      }
    } catch (error) {
      messageApi.error('Error al obtener el PDF', 3);
    }
  };

  const handleCheckboxChange = (row) => 
  {
    const updatedMonPropViaPub = {
      ...row,
      checkValidacion: !row.checkValidacion
    };
    const updatedMonPropViaPubList = [...monitoreosListCopy];
    const indexToUpdated = updatedMonPropViaPubList.findIndex(
      (p) => p.idMonitoreo === updatedMonPropViaPub.idMonitoreo
    );
    updatedMonPropViaPubList[indexToUpdated] = updatedMonPropViaPub;

    setMonitoreosListCopy(updatedMonPropViaPubList || []);
  };

  const handleValidarHallazgos = async () => 
  {
    try 
    {
      setLoadingBtnValidar(true);
      const payload = {
        monitoreos: {
          toDeValidate: [],
          toValidate: []
        }
      };
      payload.monitoreos.toValidate = getChangedValidateHallazgo(monitoreosListCopy, data);
      payload.monitoreos.toDeValidate = getChangedDeValidateHallazgo(monitoreosListCopy, data);
      if (payload.monitoreos.toValidate.length === 0) 
      {
        setLoadingBtnValidar(false);
        messageApi.open({
          type: 'error',
          content: 'Debes seleccionar al menos un monitoreo para validar.'
        });
        return;
      }
      const { success, response } = await dispatch(validarHallazgosByMoni(payload));
      if (success) 
      {
        for (let i = 0; i < payload.monitoreos.toValidate.length; i++) 
        {
          const idsHallazgos = payload.monitoreos.toValidate
            .flatMap(item => item.hallazgos.map(h => h.idHallazgo)); 

          // MNI - Llamado a la generación de PDF's al momento de validar 
          let monitoreoPDF = [{
              idMonitoreo     : payload.monitoreos.toValidate[i].idMonitoreo
            , idTipoMonitoreo : 1             
            , tiposActa       : [{ "id": 2
                                 , "idsHallazgo": idsHallazgos }] // Hallazgos
          }];

          // Se genera PDF una vez que se han almacenado las Muestras
          let generoPDF = await generarPDFMonitoreosValidacion(monitoreoPDF);
          if(generoPDF)
          {
            console.log('Se generó correctamente el PDF');
          }else{
            console.log('Error al generar el PDF');
          }  
        }
        dispatch(getMonitoreoEspectacularesViaPublica(pagination.current, pagination.pageSize));
        setIsVisibleSuccessModal(true);
        setLoadingBtnValidar(false);
      } else if (response?.causa !== undefined) {
        setLoadingBtnValidar(false);
        messageApi.error(response.causa);
      } else {
        setLoadingBtnValidar(false);
        messageApi.error(MensGrales.MAV1_2);
      }
    } catch (error) {
      setLoadingBtnValidar(false);
      messageApi.error(error);
    }
  };

  const checkBoxEstatusMonitoreo = (row) => {
    let enableChecBox = false;
    if (row.estatusMonitoreo === 'En proceso' || row.estatusMonitoreo === 'Cancelado') {
      enableChecBox = true;
    } else if (row.estatusMonitoreo === 'Terminado' && row.noHallazgos === 0) {
      enableChecBox = true;
    }
    return enableChecBox;
  };

  const renderValidacion = (_, row) => {
    const rolUsuario = getMenuPermissions(
      menu,
      NOMBRE_MENU_ESPECTACULARES,
      NOMBRE_SUBMENU_PROP_VIA_PUB,
      NOMBRE_MENU_PERMISO_EDITAR
    );
    if (rolUsuario) {
      return (
        <Checkbox
          disabled={checkBoxEstatusMonitoreo(row)}
          defaultChecked={row.checkValidacion}
          onChange={() => handleCheckboxChange(row)}
        />
      );
    }
    return <span>{row.estatusHallazgo}</span>;
  };

  const filter = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <Input
        id={columnName}
        placeholder="Escribe"
        name={columnName}
        key={columnName}
        onChange={handleChangeFilter}
      />
    </label>
  );

  const filterNoHallazgo = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <Input
        type="number"
        id={columnName}
        placeholder="Escribe"
        name={columnName}
        key={columnName}
        onChange={handleChangeFilterNumber}
      />
    </label>
  );

  const filterDateInicio = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <DatePicker
        id={columnName}
        name={columnName}
        key={columnName}
        placeholder="Escribe"
        style={{ width: '100%' }}
        allowClear
        onChange={handleChangeDateFilterInicio}
        format={DATE_FORMAT_DATE_PICKER}
      />
    </label>
  );

  const filterDateCierre = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <DatePicker
        id={columnName}
        name={columnName}
        key={columnName}
        placeholder="Escribe"
        style={{ width: '100%' }}
        allowClear
        onChange={handleChangeDateFilterCierre}
        format={DATE_FORMAT_DATE_PICKER}
      />
    </label>
  );

  const filteredList = useMemo(() => {
    const { fechaFinal, fechaInicio, folioDesde, folioHasta, idProcesoGral, idProcesoEspecifico } =
      mainFilters;
    const filteredData = data.filter((row) => {
      const folio = getFolioNumber(row.folioMonitoreo);
      if (folioDesde && folio < folioDesde) return false;
      if (folioHasta && folio > folioHasta) return false;
      if (idProcesoGral && row.idProcesoGral !== idProcesoGral) return false;
      if (idProcesoEspecifico && row.idProcesoEspecifico !== idProcesoEspecifico) return false;
      if (fechaFinal && fechaFinal < row.fechaRegistro.format('YYYY-MM-DD 00:01:00.000'))
        return false;
      if (fechaInicio && fechaInicio > row.fechaRegistro.format('YYYY-MM-DD 00:01:00.000'))
        return false;
      return true;
    });
    return filteredData;
  });

  const renderCheckboxDescarga = (_, row) => (
    <Checkbox
      defaultChecked={seleccion.current?.[row.idActaDescarga]}
      key={row.idActaDescarga}
      onChange={({ target }) => {
        const { current } = seleccion;
        current[row.idActaDescarga] = target.checked;
      }}
    />
  );

  const renderActions = (_, row) => (
    <div>
      {getMenuPermissions(
        menu,
        NOMBRE_MENU_ESPECTACULARES,
        NOMBRE_SUBMENU_PROP_VIA_PUB,
        NOMBRE_MENU_PERMISO_EDITAR
      ) && (
        <Row className="column-acciones">
          <Col span={8}>
            <Tooltip title="Editar acta de inicio" class="tooltip-acciones" placement="topLeft">
              <Button
                className="btnTblAccion"
                icon={<FileSearchOutlined className="icons-tbl-prop" />}
                onClick={() => {
                  navigate(`/simac/espectaculares/actaInicio?folio=${row.folioMonitoreo}`);
                }}
              />
            </Tooltip>
          </Col>
          <Col span={8}>
            <Tooltip title="Editar hallazgo" class="tooltip-acciones" placement="topLeft">
              <Button
                className="btnTblAccion"
                icon={<FileSearchOutlined className="icons-tbl-prop" />}
                onClick={() => {
                  navigate(`/simac/espectaculares/hallazgos?folio=${row.folioMonitoreo}`);
                }}
              />
            </Tooltip>
          </Col>
          <Col span={8}>
            <Tooltip title="Editar acta de cierre" class="tooltip-acciones" placement="topLeft">
              <Button
                className="btnTblAccion"
                icon={<FileSearchOutlined className="icons-tbl-prop" />}
                onClick={() => {
                  navigate(`/simac/espectaculares/actaCierre?folio=${row.folioMonitoreo}`);
                }}
              />
            </Tooltip>
          </Col>
        </Row>
      )}
      <Row className="column-acciones">
        <Col span={8}>
          <Tooltip title="Visualizar" class="tooltip-acciones" placement="topLeft">
            <Button
              className="btnTblAccion"
              icon={<EyeOutlined className="icons-tbl-prop" />}
              onClick={() => {
                messageApi.open({
                  content: <Spin />
                });
                const { idMonitoreo, idActaDescarga } = row;
                handleGetPdfActa(idMonitoreo, 'eyeOutlined', idActaDescarga);
              }}
            />
          </Tooltip>
        </Col>
        <Col span={8}>
          <Tooltip title="Descargar" class="tooltip-acciones" placement="topLeft">
            <Button
              className="btnTblAccion"
              icon={<DownloadOutlined className="icons-tbl-prop" />}
              onClick={() => {
                messageApi.open({
                  content: <Spin />
                });
                const { idMonitoreo, idActaDescarga } = row;
                handleGetPdfActa(idMonitoreo, 'downloadOutlined', idActaDescarga);
                console.log('row', row);
              }}
            />
          </Tooltip>
        </Col>
      </Row>
    </div>
  );

  const columns = [
    {
      title: 'Monitoreo',
      key: 'cabeceraMNT',
      children: [
        {
          title: filter('folioMonitoreo', 'Folio de monitoreo:'),
          key: 'folioMonitoreo',
          dataIndex: 'folioMonitoreo',
          width: '12%',
          className: 'my-column-tbl'
        },
        {
          title: filter('estatusMonitoreo', 'Estatus de monitoreo'),
          key: 'estatusMonitoreo',
          dataIndex: 'estatusMonitoreo',
          width: '12%',
          className: 'my-column-tbl'
        }
      ]
    },
    {
      title: 'Acta de inicio',
      key: 'cabeceraAI',
      children: [
        {
          title: filterDateInicio('fechaCreacionAI', 'Fecha de creación'),
          dataIndex: 'fechaCreacionAI',
          width: '12%',
          className: 'my-column-tbl',
          key: 'fechaCreacionAI'
        },
        {
          title: filter('estatusAI', 'Estatus'),
          dataIndex: 'estatusAI',
          width: '10%',
          className: 'my-column-tbl',
          key: 'estatusAI'
        }
      ]
    },
    {
      title: 'Hallazgos',
      key: 'cabeceraH',
      children: [
        {
          title: filterNoHallazgo('noHallazgos', 'No. de hallazgos'),
          dataIndex: 'noHallazgos',
          width: '11%',
          className: 'my-column-tbl',
          key: 'noHallazgos'
        },
        {
          title: filter('entidadHallazgo', 'Entidad'),
          dataIndex: 'entidadHallazgo',
          width: '11%',
          className: 'my-column-tbl',
          key: 'entidadHallazgo'
        },
        {
          title: getMenuPermissions(
            menu,
            NOMBRE_MENU_ESPECTACULARES,
            NOMBRE_SUBMENU_PROP_VIA_PUB,
            NOMBRE_MENU_PERMISO_EDITAR
          )
            ? 'Check de validación'
            : filter('checkValidacion', 'Estatus'),
          dataIndex: 'checkValidacion',
          width: '7%',
          className: 'my-column-tbl',
          render: renderValidacion
        }
      ]
    },
    {
      title: 'Acta de cierre',
      key: 'cabeceraAC',
      children: [
        {
          title: filterDateCierre('fechaCreacionAC', 'Fecha de creación'),
          dataIndex: 'fechaCreacionAC',
          width: '12%',
          className: 'my-column-tbl',
          key: 'fechaCreacionAC'
        },
        {
          title: filter('estatusAC', 'Estatus'),
          dataIndex: 'estatusAC',
          width: '10%',
          className: 'my-column-tbl',
          key: 'estatusAC'
        },
        {
          title: 'Check de descarga',
          dataIndex: 'checkDescargaAC',
          width: '7%',
          className: 'my-column-tbl',
          key: 'checkDescargaAC',
          render: renderCheckboxDescarga
        }
      ]
    },
    {
      title: 'Acciones',
      dataIndex: 'actions',
      align: 'center',
      width: '10%',
      key: 'actions',
      render: renderActions
    }
  ];

  useEffect(() => 
  {
    const getDataMonPropViaPublica = async () => 
    {
      try {
        const { success, totalActas } = await dispatch(
          getMonitoreoEspectacularesViaPublica(pagination.current, pagination.pageSize)
          // getMonitoreoEspectacularesViaPublica() // MNI - Se comenta para enviar datos de paginación
        );
        if (success && totalActas > 0) {
          setPagination((prev) => ({
            ...prev,
            total: totalActas
          }));
        }
      } catch (error) {
        console.log('Error', error);
      }
    };

    getDataMonPropViaPublica();
    setMonitoreosListCopy(data);
  }, [pagination.current, pagination.pageSize]);

  const dataList = useMemo(() => {
    return filterList(filteredList, filters);
  }, [filteredList, filters]);

  return (
    <div className="tabla-monitoreo">
      <InfoModal
        visible={isVisibleSuccesModal}
        onClose={() => {
          setIsVisibleSuccessModal(false);
        }}
        description="Los monitoreos se validaron correctamente."
      />
      <ModalPdf
        open={isModalPdfOpen}
        pdfActa={pdfActa}
        tipoActa={PDF_ACTA_INICIO}
        callback={() => setIsModalPdfOpen(false)}
        idActa={isActaDescargaId}
        idMonitoreo={isMonitoreoId}
      />
      <div className="table-header">
        <SelectTamanoPagina
          value={pagination.pageSize}
          onChange={handleChangePageSize}
          disableBottomExcel={downloadingExcel}
          onClick={handleDownloadExcel}
        />
      </div>
      {contextHolder}
      <Table
        bordered={false}
        columns={columns}
        dataSource={dataList}
        pagination={{
          ...pagination,
          onChange: (page, pageSize) => {
            setPagination((prev) => ({
              ...prev,
              current: page,
              pageSize: pageSize || prev.pageSize
            }));
          }
        }}
        loading={loading}
        rowKey={generateId()}
      />
      {getMenuPermissions(
        menu,
        NOMBRE_MENU_ESPECTACULARES,
        NOMBRE_SUBMENU_PROP_VIA_PUB,
        NOMBRE_MENU_PERMISO_VALIDAR
      ) && (
        <div className="btn-validar">
          <Button
            type="primary"
            text="Validar hallazgos"
            size="large"
            loading={loading || loadingBtnValidar}
            onClick={handleValidarHallazgos}
          />
        </div>
      )}
    </div>
  );
};

export default TablaMonitoreos;

TablaMonitoreos.propTypes = {
  mainFilters: PropTypes.shape({
    fechaFinal: PropTypes.shape({}),
    fechaInicio: PropTypes.shape({}),
    folioDesde: PropTypes.number,
    folioHasta: PropTypes.number,
    idProcesoGral: PropTypes.number,
    idProcesoEspecifico: PropTypes.number
  }).isRequired,
  seleccion: PropTypes.shape({
    current: PropTypes.shape({})
  }).isRequired
};
